import { memo, useState } from 'react'
import Skeleton from '../skeleton/Skeleton'
import CarInfoModal from '../modal/CarInfoModal'
import { priceFormat } from '../../assets/scripts/GeneralFunctions'

function CarInfoTable({ car_models, car, setCar, isUser = false }) {
  const [showModal, setShowModal] = useState(false)
  const editCar = () => {
    setShowModal(true)
  }

  return (
    <>
      <div className="relative rounded-2xl border border-light-gray dark:border-gray-700 overflow-auto scroll-smooth">
        <table className="w-full text-sm text-right relative whitespace-nowrap">
          <thead className="text-md bg-light-blue dark:bg-slate-800 w-full">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700 text-center'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نوع
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                رنگ
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                میانگین کیلومتر در ماه
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                پلاک
              </th>
              {!isUser && (
                <th scope="col" className="px-6 py-4 dark:text-amber-100">
                  عملیات
                </th>
              )}
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {car?.code ? (
              <tr className="border-b border-b-light-gray dark:border-b-gray-700 text-center">
                <td className="px-6 py-4 dark:text-amber-50">{car?.car_model?.model}</td>
                <td className="px-6 py-4 dark:text-amber-50">{car?.color}</td>
                <td className="px-6 py-4 dark:text-amber-50">
                  {car?.monthly_ride ? priceFormat(car?.monthly_ride) : '- - -'}
                </td>
                <td className="px-6 py-4 dark:text-amber-50">
                  {car?.aras_plate ? (
                    car?.aras_plate
                  ) : (
                    <>
                      {car?.['plate_number']?.['first']} {car?.['plate_number']?.['letter']}{' '}
                      {car?.['plate_number']?.['second']} - ایران {car?.['plate_number']?.['state']}
                    </>
                  )}
                </td>
                {!isUser && (
                  <td className="px-6 py-4">
                    <button
                      onClick={editCar}
                      className="font-medium text-link dark:text-link hover:underline"
                    >
                      ویرایش
                    </button>
                  </td>
                )}
              </tr>
            ) : (
              <tr className="border-b border-b-light-gray text-center">
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                <td className="px-6 py-4">
                  <Skeleton />
                </td>
                {!isUser && (
                  <td className="px-6 py-4">
                    <Skeleton />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showModal && (
        <CarInfoModal
          car_models={car_models}
          car={car}
          setShowModal={setShowModal}
          setCar={setCar}
        />
      )}
    </>
  )
}

export default memo(CarInfoTable)
